import { CImage } from "@coreui/react-pro";
import React, { useEffect } from "react";
import {
  Navigate,
  Outlet,
  Redirect,
  Route,
  Routes,
  Switch,
} from "react-router-dom";
import { Login } from "./components/Login";

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add("bg-white");
    return () => {
      document.body.classList.remove("bg-white");
    };
  }, []);

  return (
    <div className="h-100vh" style={{ height: "100vh", background: "#c8dfff" }}>
      <div
        className=" d-flex  align-items-center position-absolute top-0 w-100 bg-white "
        style={{ height: 65, zIndex: 10 }}
      >
        <span className="fs-3 text-center h-100 mt-3 ms-5  ">
          {" "}
          <CImage src="/sabakLogo.png" height={48} alt="Logo" />
        </span>
      </div>
      {/* begin::Content */}
      <div className="d-flex flex-wrap justify-content-center align-items-center border-none border-radius radius-10 rounded h-100 ">
        {/* begin::Logo */}
        <a href="#" className="mb-12">
          <div></div>
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div
          className="mx-auto p-5 card rounded-3 shadow w-75"
          style={{ maxWidth: 475 }}
        >
          <Routes>
            <Route element={<Outlet />}>
              <Route path="login" element={<Login />} />
              <Route index element={<Login />} />
            </Route>
          </Routes>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className="d-flex flex-center flex-column-auto p-2 bg-light w-100 position-absolute bottom-0 ">
        <div className="d-flex align-items-center fw-bold fs-6">
          <span className="text-muted text-hover-primary px-2">
            <a href="https://www.bestera.com.tr/rutist">bestERA</a>{" "}
            {new Date().getFullYear()}
          </span>
        </div>
      </div>
      {/* end::Footer */}
    </div>
  );
}
